export default "__VITE_ASSET__THdryzrR__"